export default ['templateFactory', function () {
    'ngInject';

    return {

    };
}];



// WEBPACK FOOTER //
// ./src/app/services/templateFactory.js